import OrderSummary from './OrderSummary.styled';

export default OrderSummary;
